import { useEffect, useState } from 'react';
import { Timestamp } from '../services/Timestamp';

export const useLiveTimestamp = (): Timestamp => {
  const [liveTimestamp, setLiveTimestamp] = useState(Timestamp.now());

  useEffect(() => {
    const timeout = setInterval(() => {
      setLiveTimestamp(Timestamp.now());
    }, Timestamp.fromSeconds(1).toMilliseconds());

    return (): void => {
      clearTimeout(timeout);
    };
  }, []);

  return liveTimestamp;
};
